import 'angular:locale/data:en-ZA';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "en-ZA";
